<template>
    <v-row v-if="newClient">
        <v-col :cols="6">
            <v-text-field
                v-model="newClient.firstName"
                :label="`${$t('first_name')}*`"
                persistent-placeholder
                :rules="validationRules('first_name', [requiredRule])"
                variant="outlined"
            />
        </v-col>
        <v-col :cols="6">
            <v-text-field
                v-model="newClient.lastName"
                :label="`${$t('last_name')}*`"
                persistent-placeholder
                :rules="validationRules('last_name', [requiredRule])"
                variant="outlined"
            />
        </v-col>
        <v-col :cols="6">
            <phone-field v-model="newClient.contactPhone" :label="$t('phone')" persistent-placeholder />
        </v-col>
        <v-col :cols="6">
            <v-text-field
                v-model="newClient.email"
                :label="`${$t('email')}${allowOptionalEmail ? '' : '*'}`"
                persistent-placeholder
                type="email"
                variant="outlined"
                :rules="validationRules('email', [emailRule, ...(allowOptionalEmail ? [] : [requiredRule])])"
            />
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, mixins, VModel, Prop} from 'vue-facing-decorator'
    import ClientAutocomplete from '@/components/account/modals/newOrderRequest/ClientAutocomplete.vue'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import PhoneField from '@/components/snippets/forms/PhoneField.vue'

    @Component({
        components: {PhoneField, ClientAutocomplete},
    })
    export class CreateNewClient extends mixins(FormValidationRulesMixin) {
        @VModel() newClient
        @Prop({default: false, type: Boolean}) allowOptionalEmail
    }

    export default CreateNewClient
</script>
